module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAASFBMVEVMaXEAAABQUFBQUFBRUVFVVVVMTExQUFBRUVFQUFBQUFBQUFBQUFBQUFBQUFBRUVFQUFBQUFBRUVFVVVVSUlJVVVVRUVFRUVGZLCYLAAAAF3RSTlMAAZ9L8gYD0MBcUvutvpJltOwsHiUYie0dVmgAAACKSURBVHjarZLbCsIwDIb/ns+1ddO8/5s62FS6FHah30UJ+UoISfDFtmIwQUiibMF5Uu9JCpaPdPNue5h4RHgHdceETQC/ibCOYg17/5XiKCJVARiZwrlUSNKgkXYHOn0iaijU/YHW76hTgcmzUtkAtpIahaJq9w/LKJbw95HwsV8viq/2+hj4+bwAVpUHHuQ+CoQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/icon-move.png
// module id = KEER
// module chunks = 0